import { useHook } from './hooks'
import styles from './styles.module.scss'
import { Button, Row, Space, Image } from 'antd'
import Search from '../../components/SearchFilter'
import Buttonbar from '../../components/ButtonBar'
import TableAntd from '../../components/TableAntd'
import { GetLocalStorage } from '../../tools/util'
export default function MyBrand() {
  const {
    pages,
    dataSource,
    onAddBrand,
    handleSearchClick,
    handleTableRefresh,
    handlePaginationChange,
    onJump,
  } = useHook()

  const logoRender = (text: string) => {
    return (
      <Space>
        {text && (
          <Image
            width={100}
            height={40}
            src={GetLocalStorage('BASEURL') + text}
          />
        )}
      </Space>
    )
  }

  const manageTypeList = [
    {
      name: '品牌方',
      value: '1',
    },
    {
      name: '集货商',
      value: '2',
    },
  ]

  const getManageType = (text: string) => {
    const manage = manageTypeList.find((item) => item.value === text)
    return manage?.name
  }

  const columns = [
    {
      key: 'brandLogoUrl',
      dataIndex: 'brandLogoUrl',
      title: '品牌Logo',
      render: logoRender,
    },
    {
      key: 'brandCode',
      dataIndex: 'brandCode',
      title: '品牌编码',
      render: (text: any, record: any) => (
        <span className="primaryBtn" onClick={() => onJump(record)}>
          {text}
        </span>
      ),
    },
    {
      key: 'brandNameCn',
      dataIndex: 'brandNameCn',
      title: '品牌中文名',
    },
    {
      key: 'brandNameEn',
      dataIndex: 'brandNameEn',
      title: '品牌英文名',
    },
    {
      key: 'manageType',
      dataIndex: 'manageType',
      title: '经营形式',
      render: getManageType,
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={['brandCode', 'brandNameCn', 'brandNameEn', 'manageType']}
        onSearch={handleSearchClick}
        keyName="BRAND"
        ScreenKey="BRAND"
      />
      <Row justify="space-between" className={styles['info-row']}>
        <Space>
          <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        </Space>
        <Space>
          <Button type="primary" onClick={onAddBrand}>
            新增
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={columns}
        loading={dataSource.loading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: pages.pageNo,
          pagesize: pages.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize
      ></TableAntd>
    </div>
  )
}
import { useHook } from './hooks'
import styles from './styles.module.scss'
import { Button, Row, Space, Image } from 'antd'
import Search from '../../components/SearchFilter'
import Buttonbar from '../../components/ButtonBar'
import TableAntd from '../../components/TableAntd'
import { GetLocalStorage } from '../../tools/util'
export default function MyBrand() {
  const {
    pages,
    dataSource,
    onAddBrand,
    handleSearchClick,
    handleTableRefresh,
    handlePaginationChange,
    onJump,
  } = useHook()

  const logoRender = (text: string) => {
    return (
      <Space>
        {text && (
          <Image
            width={100}
            height={40}
            src={GetLocalStorage('BASEURL') + text}
          />
        )}
      </Space>
    )
  }

  const manageTypeList = [
    {
      name: '品牌方',
      value: '1',
    },
    {
      name: '集货商',
      value: '2',
    },
  ]

  const getManageType = (text: string) => {
    const manage = manageTypeList.find((item) => item.value === text)
    return manage?.name
  }

  const columns = [
    {
      key: 'brandLogoUrl',
      dataIndex: 'brandLogoUrl',
      title: '品牌Logo',
      render: logoRender,
    },
    {
      key: 'brandCode',
      dataIndex: 'brandCode',
      title: '品牌编码',
      render: (text: any, record: any) => (
        <span className="primaryBtn" onClick={() => onJump(record)}>
          {text}
        </span>
      ),
    },
    {
      key: 'brandNameCn',
      dataIndex: 'brandNameCn',
      title: '品牌中文名',
    },
    {
      key: 'brandNameEn',
      dataIndex: 'brandNameEn',
      title: '品牌英文名',
    },
    {
      key: 'manageType',
      dataIndex: 'manageType',
      title: '经营形式',
      render: getManageType,
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={['brandCode', 'brandNameCn', 'brandNameEn', 'manageType']}
        onSearch={handleSearchClick}
        keyName="BRAND"
        ScreenKey="BRAND"
      />
      <Row justify="space-between" className={styles['info-row']}>
        <Space>
          <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        </Space>
        <Space>
          <Button type="primary" onClick={onAddBrand}>
            新增
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource.data}
        listColumn={columns}
        loading={dataSource.loading}
        Y={340}
        pagination={{
          total: dataSource.total,
          current: pages.pageNo,
          pagesize: pages.pageSize,
          onChange: handlePaginationChange,
        }}
        showSize
      ></TableAntd>
    </div>
  )
}
